export const categories = [
  { slug: 'guoman', name: '国漫', icon: 'ri-flag-line', count: 1280, description: '国产精品漫画，涵盖玄幻、修真、都市、穿越等热门题材' },
  { slug: 'riman', name: '日漫', icon: 'ri-earth-line', count: 3560, description: '日本经典漫画，热血、恋爱、冒险、悬疑一网打尽' },
  { slug: 'hanman', name: '韩漫', icon: 'ri-global-line', count: 890, description: '韩国人气条漫，精致画风，精彩剧情' },
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', count: 760, description: '燃到爆的热血漫画，战斗、成长、友情' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', count: 920, description: '甜蜜浪漫的恋爱故事，心动瞬间' },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-magic-line', count: 1040, description: '奇幻世界冒险，修真成仙，逆天改命' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', count: 340, description: '未来世界，星际探索，科技幻想' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', count: 480, description: '烧脑推理，惊险刺激的悬疑故事' },
  { slug: 'wanjie', name: '完结', icon: 'ri-check-double-line', count: 2150, description: '已完结漫画，一口气看到爽' },
  { slug: 'lianzai', name: '连载', icon: 'ri-loader-4-line', count: 3980, description: '正在连载中，每日追更不等待' },
];

export const comics = [
  {
    id: 1,
    title: '斗破苍穹',
    author: '天蚕土豆',
    category: 'guoman',
    subCategory: 'xuanhuan',
    status: '连载',
    rating: 9.5,
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20manhua%20cover%20featuring%20a%20young%20martial%20artist%20in%20flowing%20robes%20surrounded%20by%20golden%20flames%2C%20ancient%20Chinese%20fantasy%20style%2C%20dynamic%20composition%2C%20warm%20golden%20and%20crimson%20tones%2C%20clean%20background%20with%20soft%20gradient%2C%20professional%20manga%20illustration%20style&width=400&height=560&seq=manga-doupo-cangqiong&orientation=portrait',
    chapters: 1523,
    updateDate: '2026-08-04',
    description: '这里是属于斗气的世界，没有花俏艳丽的魔法，有的，仅仅是繁衍到巅峰的斗气！',
    tags: ['玄幻', '热血', '战斗', '国漫'],
    views: 12500000,
  },
  {
    id: 2,
    title: '海贼王',
    author: '尾田荣一郎',
    category: 'riman',
    subCategory: 'rexue',
    status: '连载',
    rating: 9.8,
    cover: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Japanese%20manga%20cover%20showing%20a%20smiling%20pirate%20boy%20in%20a%20straw%20hat%20with%20a%20pirate%20ship%20and%20ocean%20waves%20in%20background%2C%20bright%20blue%20sky%2C%20adventure%20theme%2C%20clean%20illustration%20style%2C%20warm%20lighting&width=400&height=560&seq=manga-one-piece&orientation=portrait',
    chapters: 1120,
    updateDate: '2026-08-03',
    description: '拥有财富、名声、权力，这世界上的一切的男人"海贼王"哥尔·D·罗杰，在被行刑受死之前说了一句话，让全世界的人都涌向了大海。',
    tags: ['热血', '冒险', '友情', '日漫'],
    views: 28500000,
  },
  {
    id: 3,
    title: '我独自升级',
    author: 'Chugong',
    category: 'hanman',
    subCategory: 'rexue',
    status: '完结',
    rating: 9.4,
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20stylish%20Korean%20webtoon%20cover%20depicting%20a%20cool%20hunter%20in%20black%20armor%20with%20glowing%20purple%20eyes%2C%20shadow%20army%20behind%20him%2C%20dark%20atmospheric%20background%2C%20professional%20manhwa%20art%20style%2C%20dramatic%20lighting&width=400&height=560&seq=manga-solo-leveling&orientation=portrait',
    chapters: 179,
    updateDate: '2026-06-15',
    description: '10年前，世界开始出现连接异次元的"门"，同时，也有少部分人觉醒了超能力，他们被称为"猎人"。',
    tags: ['热血', '战斗', '系统', '韩漫'],
    views: 18600000,
  },
  {
    id: 4,
    title: '完美世界',
    author: '辰东',
    category: 'guoman',
    subCategory: 'xuanhuan',
    status: '连载',
    rating: 9.3,
    cover: 'https://readdy.ai/api/search-image?query=A%20grand%20Chinese%20fantasy%20manhua%20cover%20with%20a%20powerful%20youth%20in%20white%20robes%20standing%20on%20a%20mountain%20peak%2C%20ancient%20palaces%20and%20clouds%20below%2C%20celestial%20beings%2C%20golden%20and%20white%20color%20palette%2C%20epic%20scale&width=400&height=560&seq=manga-wanmei-shijie&orientation=portrait',
    chapters: 980,
    updateDate: '2026-08-04',
    description: '一粒尘可填海，一根草斩尽日月星辰，弹指间天翻地覆。群雄并起，万族林立，诸圣争霸。',
    tags: ['玄幻', '热血', '修真', '国漫'],
    views: 9800000,
  },
  {
    id: 5,
    title: '辉夜大小姐想让我告白',
    author: '赤坂明',
    category: 'riman',
    subCategory: 'lianai',
    status: '完结',
    rating: 9.2,
    cover: 'https://readdy.ai/api/search-image?query=A%20sweet%20romantic%20Japanese%20manga%20cover%20showing%20a%20beautiful%20schoolgirl%20and%20handsome%20schoolboy%20in%20school%20uniforms%20with%20blushing%20expressions%2C%20cherry%20blossoms%20and%20soft%20pink%20background%2C%20romantic%20comedy%20style%2C%20warm%20lighting&width=400&height=560&seq=manga-kaguya-sama&orientation=portrait',
    chapters: 281,
    updateDate: '2026-05-20',
    description: '在名门秀知院学园，学生会会长与副会长每天都想让对方先告白，这场恋爱头脑战从未停止。',
    tags: ['恋爱', '喜剧', '校园', '日漫'],
    views: 7200000,
  },
  {
    id: 6,
    title: '全职高手',
    author: '蝴蝶蓝',
    category: 'guoman',
    subCategory: 'kehuan',
    status: '完结',
    rating: 9.6,
    cover: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Chinese%20esports%20manhua%20cover%20with%20a%20cool%20male%20gamer%20holding%20a%20mouse%20and%20keyboard%2C%20digital%20game%20effects%20and%20holographic%20particles%20surrounding%20him%2C%20dark%20background%20with%20neon%20accents%2C%20modern%20style&width=400&height=560&seq=manga-quanzhi-gaoshou&orientation=portrait',
    chapters: 620,
    updateDate: '2026-04-10',
    description: '网游荣耀中被誉为教科书级别的顶尖高手叶修，因为种种原因遭到俱乐部的驱逐。离开职业圈的他寄身于一家网吧成了一个小小的网管。',
    tags: ['电竞', '热血', '游戏', '国漫'],
    views: 15300000,
  },
  {
    id: 7,
    title: '神之塔',
    author: 'SIU',
    category: 'hanman',
    subCategory: 'xuanhuan',
    status: '连载',
    rating: 9.1,
    cover: 'https://readdy.ai/api/search-image?query=A%20mysterious%20Korean%20webtoon%20cover%20depicting%20a%20massive%20tower%20reaching%20into%20the%20sky%20with%20a%20young%20boy%20climbing%20it%2C%20colorful%20magical%20effects%2C%20dark%20and%20mystical%20atmosphere%2C%20professional%20manhwa%20art&width=400&height=560&seq=manga-tower-of-god&orientation=portrait',
    chapters: 580,
    updateDate: '2026-08-02',
    description: '只要登到塔顶，就能得到任何想要的东西。蕾哈尔为了看星星而决定登塔，二十五夜为了追随她而一同进入。',
    tags: ['冒险', '奇幻', '战斗', '韩漫'],
    views: 5600000,
  },
  {
    id: 8,
    title: '咒术回战',
    author: '芥见下下',
    category: 'riman',
    subCategory: 'rexue',
    status: '连载',
    rating: 9.3,
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20supernatural%20Japanese%20manga%20cover%20featuring%20a%20teenage%20sorcerer%20with%20spiky%20hair%20and%20dark%20uniform%2C%20cursed%20energy%20swirling%20around%2C%20urban%20Tokyo%20background%2C%20dramatic%20red%20and%20black%20color%20scheme&width=400&height=560&seq=manga-jujutsu-kaisen&orientation=portrait',
    chapters: 260,
    updateDate: '2026-08-04',
    description: '少年虎杖悠仁吞下了诅咒之王两面宿傩的手指，由此展开了与诅咒战斗的宿命之旅。',
    tags: ['热血', '战斗', '奇幻', '日漫'],
    views: 11200000,
  },
  {
    id: 9,
    title: '仙王的日常生活',
    author: '枯玄',
    category: 'guoman',
    subCategory: 'xuanhuan',
    status: '连载',
    rating: 8.9,
    cover: 'https://readdy.ai/api/search-image?query=A%20humorous%20Chinese%20manhua%20cover%20showing%20a%20lazy%20looking%20teenage%20boy%20in%20school%20uniform%20but%20with%20immortal%20cultivation%20aura%20around%20him%2C%20modern%20school%20and%20ancient%20fantasy%20elements%20mixed%2C%20playful%20style&width=400&height=560&seq=manga-xianwang&orientation=portrait',
    chapters: 450,
    updateDate: '2026-08-03',
    description: '六岁就无敌的仙王王令，只想低调地过平凡的校园生活。可惜天不遂人愿。',
    tags: ['搞笑', '校园', '修仙', '国漫'],
    views: 6700000,
  },
  {
    id: 10,
    title: '间谍过家家',
    author: '远藤达哉',
    category: 'riman',
    subCategory: 'lianai',
    status: '连载',
    rating: 9.5,
    cover: 'https://readdy.ai/api/search-image?query=A%20charming%20Japanese%20manga%20cover%20featuring%20a%20stylish%20family%20of%20three%20in%20formal%20attire%20with%20a%20spy%20theme%2C%20elegant%20composition%2C%20warm%20cream%20and%20burgundy%20color%20palette%2C%20clean%20illustration%20style&width=400&height=560&seq=manga-spy-family&orientation=portrait',
    chapters: 95,
    updateDate: '2026-08-04',
    description: '为了执行任务，间谍黄昏组建了一个虚假的家庭。但他不知道，妻子是杀手，女儿是超能力者。',
    tags: ['喜剧', '家庭', '间谍', '日漫'],
    views: 9200000,
  },
  {
    id: 11,
    title: '龙族',
    author: '江南',
    category: 'guoman',
    subCategory: 'kehuan',
    status: '连载',
    rating: 9.0,
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Chinese%20manhua%20cover%20depicting%20a%20young%20man%20with%20dragon%20scales%20on%20his%20skin%2C%20ancient%20dragon%20silhouette%20in%20background%2C%20modern%20city%20and%20fantasy%20elements%20combined%2C%20dark%20and%20golden%20toned&width=400&height=560&seq=manga-longzu&orientation=portrait',
    chapters: 320,
    updateDate: '2026-08-01',
    description: '你年少时是否曾想过，世界上存在龙？一个关于龙的故事，一个关于守护的故事。',
    tags: ['奇幻', '冒险', '热血', '国漫'],
    views: 8500000,
  },
  {
    id: 12,
    title: '某天成为公主',
    author: 'Plutus',
    category: 'hanman',
    subCategory: 'lianai',
    status: '完结',
    rating: 9.3,
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20webtoon%20cover%20showing%20a%20lovely%20princess%20in%20an%20elegant%20gown%20with%20long%20flowing%20hair%2C%20royal%20palace%20and%20rose%20garden%20background%2C%20soft%20pastel%20pink%20and%20gold%20tones%2C%20delicate%20art%20style&width=400&height=560&seq=manga-princess&orientation=portrait',
    chapters: 125,
    updateDate: '2026-03-28',
    description: '一觉醒来，我变成了小说中注定要被父亲杀死的悲情公主。为了活命，必须攻略那个冷酷的父皇！',
    tags: ['恋爱', '穿越', '宫廷', '韩漫'],
    views: 5100000,
  },
  {
    id: 13,
    title: '进击的巨人',
    author: '谏山创',
    category: 'riman',
    subCategory: 'xuanyi',
    status: '完结',
    rating: 9.7,
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20intense%20Japanese%20manga%20cover%20showing%20a%20giant%20titan%20looming%20over%20a%20walled%20city%2C%20soldiers%20with%20maneuver%20gear%20flying%20towards%20it%2C%20apocalyptic%20atmosphere%2C%20dramatic%20lighting%2C%20grim%20color%20palette&width=400&height=560&seq=manga-aot&orientation=portrait',
    chapters: 139,
    updateDate: '2026-02-15',
    description: '107年前，世界上突然出现了人类的天敌"巨人"。面临着生存危机而残存下来的人类逃到了一个地方，盖起了三重巨大的城墙。',
    tags: ['黑暗', '战斗', '悬疑', '日漫'],
    views: 22000000,
  },
  {
    id: 14,
    title: '大王饶命',
    author: '会说话的肘子',
    category: 'guoman',
    subCategory: 'xuanhuan',
    status: '连载',
    rating: 9.1,
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20Chinese%20manhua%20cover%20with%20a%20mischievous%20teenager%20smirking%2C%20glowing%20magic%20system%20panel%20floating%20beside%20him%2C%20modern%20urban%20and%20fantasy%20cultivation%20elements%2C%20bright%20and%20playful%20color%20scheme&width=400&height=560&seq=manga-dawang-raoming&orientation=portrait',
    chapters: 780,
    updateDate: '2026-08-04',
    description: '灵气复苏的时代，吕树靠着怼人就能变强的系统，开始了他的嘴炮修仙之路。',
    tags: ['搞笑', '系统', '修仙', '国漫'],
    views: 10800000,
  },
  {
    id: 15,
    title: '鬼灭之刃',
    author: '吾峠呼世晴',
    category: 'riman',
    subCategory: 'rexue',
    status: '完结',
    rating: 9.6,
    cover: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20Japanese%20manga%20cover%20featuring%20a%20young%20demon%20slayer%20with%20a%20sword%2C%20water%20breathing%20effects%20in%20blue%2C%20snowy%20mountain%20background%2C%20traditional%20Japanese%20art%20influence%2C%20beautiful%20composition&width=400&height=560&seq=manga-demonslayer&orientation=portrait',
    chapters: 205,
    updateDate: '2026-01-20',
    description: '时值日本大正时期。卖炭少年炭治郎平凡而幸福的日常生活，在家人遭到恶鬼袭击的那一天发生了剧变。',
    tags: ['热血', '战斗', '和风', '日漫'],
    views: 19500000,
  },
  {
    id: 16,
    title: '星辰变',
    author: '我吃西红柿',
    category: 'guoman',
    subCategory: 'xuanhuan',
    status: '连载',
    rating: 9.2,
    cover: 'https://readdy.ai/api/search-image?query=A%20cosmic%20Chinese%20fantasy%20manhua%20cover%20showing%20a%20cultivator%20floating%20among%20stars%20and%20galaxies%2C%20celestial%20energy%20coursing%20through%20space%2C%20epic%20scale%2C%20deep%20blue%20and%20golden%20color%20palette&width=400&height=560&seq=manga-xingchen-bian&orientation=portrait',
    chapters: 680,
    updateDate: '2026-08-02',
    description: '一名孩童，天生无法修炼内功。为了得到父亲的重视关注，他毅然选择了修炼痛苦艰难的外功。',
    tags: ['玄幻', '修真', '冒险', '国漫'],
    views: 7600000,
  },
];

export const chapters = [
  { id: 1, comicId: 1, number: 1523, title: '第1523话 斗帝之路', date: '2026-08-04' },
  { id: 2, comicId: 1, number: 1522, title: '第1522话 最后的试炼', date: '2026-08-03' },
  { id: 3, comicId: 1, number: 1521, title: '第1521话 远古遗迹', date: '2026-08-02' },
  { id: 4, comicId: 1, number: 1520, title: '第1520话 神秘来客', date: '2026-08-01' },
  { id: 5, comicId: 1, number: 1519, title: '第1519话 九星斗圣', date: '2026-07-31' },
  { id: 6, comicId: 1, number: 1518, title: '第1518话 决战在即', date: '2026-07-30' },
  { id: 7, comicId: 1, number: 1517, title: '第1517话 联盟成立', date: '2026-07-29' },
  { id: 8, comicId: 1, number: 1516, title: '第1516话 魂殿来袭', date: '2026-07-28' },
  { id: 9, comicId: 1, number: 1515, title: '第1515话 萧族回归', date: '2026-07-27' },
  { id: 10, comicId: 1, number: 1514, title: '第1514话 天火三玄变', date: '2026-07-26' },
];

export const siteInfo = {
  name: '古古漫画网',
  slogan: '追更连载，免费全集下拉式阅读',
  description: '古古漫画网是国内领先的漫画在线阅读平台，致力于为广大漫画爱好者提供最新、最快、最全的漫画阅读体验。我们收录了海量的国漫、日漫、韩漫资源，每日实时更新连载，支持免费全集下拉式阅读，让您随时随地畅享漫画世界。',
  founded: '2020年',
  users: '超过500万注册用户',
  comics: '超过20000部漫画作品',
  updates: '每日更新超过200部',
  values: [
    { title: '正版授权', description: '我们与国内外多家漫画平台和出版社建立了合作关系，确保每一部作品都经过正版授权，为创作者提供应有的回报。' },
    { title: '极致体验', description: '采用先进的下拉式阅读模式，流畅的加载速度，清晰的画质呈现，为您打造极致的阅读体验。' },
    { title: '海量资源', description: '涵盖国漫、日漫、韩漫等多个品类，热血、恋爱、玄幻、科幻等各类题材应有尽有。' },
    { title: '实时更新', description: '漫画更新团队7x24小时待命，第一时间为您带来最新连载，决不让你错过任何精彩。' },
    { title: '免费阅读', description: '坚持免费全集模式，让每一位漫画爱好者都能无障碍地享受漫画带来的乐趣。' },
    { title: '社区互动', description: '活跃的漫画社区，书评、讨论、投票、打榜，与万千漫友一起分享漫画的快乐。' },
  ],
  contact: {
    email: 'contact@gugumanga.com',
    weibo: '@古古漫画网',
    wechat: 'gugumanga2020',
    address: '北京市朝阳区望京SOHO T2-B座 1208室',
    phone: '400-888-6666',
  },
  faqs: [
    { question: '古古漫画网的漫画都是免费的吗？', answer: '是的！古古漫画网坚持免费全集模式，所有漫画均可免费阅读，无需付费订阅。我们通过广告收入维持运营，让每一位用户都能畅享漫画世界。' },
    { question: '漫画更新频率是怎样的？', answer: '我们的更新团队7x24小时实时追踪各大漫画平台的最新动态。热门连载漫画基本能做到与官方同步更新，每日上午和晚间是主要的更新时段。' },
    { question: '支持手机端阅读吗？', answer: '当然支持！古古漫画网采用响应式设计，完美适配手机、平板和电脑。在手机上采用下拉式阅读模式，体验流畅自然。' },
    { question: '如何搜索我想看的漫画？', answer: '您可以通过顶部的搜索框直接搜索漫画名称或作者，也可以在分类页面按题材、地区、状态等条件筛选。我们还提供了人气排行和最新上架等推荐模块。' },
    { question: '可以下载漫画离线阅读吗？', answer: '目前古古漫画网只支持在线浏览阅读，暂不提供下载功能。不过只要您有网络连接，就可以随时随地畅享阅读体验。' },
  ],
};